module.exports = __webpack_public_path__ + "img/Erkunden.f764bd52.svg";